import {ImmunizationVaricellaViewNew} from "./ImmunizationVaricellaViewNew";

export default ImmunizationVaricellaViewNew;
